import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { PhoneCall } from 'react-feather';

import { useCallNumber } from '../store/slices/dialSlice';

const CallInProgress = () => {
  const callNumber = useCallNumber();

  const ringBaseStyle = {
    position: 'absolute',
    width: '80px',
    height: '80px',
    borderRadius: '50%',
    backgroundColor: '#28a745',
    animation: 'callRipple 2.4s ease-out infinite'
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center bg-light"
      style={{ minHeight: 'calc(100vh - 150px)' }}>
      <style>{`
        @keyframes callRipple {
          0% { transform: scale(0.9); opacity: 0.45; }
          100% { transform: scale(2); opacity: 0; }
        }
      `}</style>
      <Container>
        <Row className="justify-content-center text-center">
          <Col md="7" lg="5">
            <div className="bg-white p-5 rounded shadow-sm">
              <div
                className="position-relative d-inline-flex justify-content-center align-items-center mb-4"
                style={{ width: '80px', height: '80px' }}>
                <span style={ringBaseStyle} />
                <span style={{ ...ringBaseStyle, animationDelay: '1.2s' }} />
                <div
                  className="position-relative bg-success rounded-circle d-flex justify-content-center align-items-center"
                  style={{ width: '80px', height: '80px' }}>
                  <PhoneCall size={38} className="text-white" />
                </div>
              </div>

              <h3 className="fw-semibold mb-2">Call in progress</h3>

              {callNumber ? (
                <p className="fs-5 fw-bold text-success mb-2">{callNumber}</p>
              ) : null}

              <p className="text-muted mb-0">
                Please continue your conversation. Use the call panel to manage this call.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CallInProgress;

